export default "__VITE_ASSET__e3yaB8Hu__"